// extracted by mini-css-extract-plugin
module.exports = {"section":"_2agIu","image":"_2qY5O","text":"_2BBeq","imageImg":"_1oE-I","textStartDate":"_2yEAy","textName":"_3U0yG","textLiveLabel":"_2MrNR","textLive":"_3Yznm","glow":"_1OpcZ"};